import { RequestPurposeType } from "../../shared/services/request-purpose.service";
var ExperimentDetailsShowHideService = /** @class */ (function () {
    function ExperimentDetailsShowHideService() {
    }
    Object.defineProperty(ExperimentDetailsShowHideService.prototype, "seedPacketDate", {
        get: function () { return this.experimentDetailsFormGroup.get("seedPacketDate"); },
        enumerable: true,
        configurable: true
    });
    ;
    ExperimentDetailsShowHideService.prototype.updateView = function (formGroup, requestPurpose) {
        this.experimentDetailsFormGroup = formGroup;
        this.enableAllDisabledFields();
        switch (requestPurpose) {
            case RequestPurposeType.BiomassInFlats: {
                this.biomassInFlats();
                break;
            }
            case RequestPurposeType.BiomassInPots: {
                this.biomassInPots();
                break;
            }
            case RequestPurposeType.PollinationAndImmatureHarvest: {
                this.pollinationAndImmatureHarvest();
                break;
            }
            default: {
                break;
            }
        }
        this.experimentDetailsFormGroup.updateValueAndValidity();
    };
    ExperimentDetailsShowHideService.prototype.biomassInFlats = function () {
        this.disableHarvestedSeedAvailableInPacketDate();
    };
    ExperimentDetailsShowHideService.prototype.biomassInPots = function () {
        this.disableHarvestedSeedAvailableInPacketDate();
    };
    ExperimentDetailsShowHideService.prototype.pollinationAndImmatureHarvest = function () {
        this.disableHarvestedSeedAvailableInPacketDate();
    };
    ExperimentDetailsShowHideService.prototype.disableHarvestedSeedAvailableInPacketDate = function () {
        this.seedPacketDate.disable();
    };
    ExperimentDetailsShowHideService.prototype.enableAllDisabledFields = function () {
        this.seedPacketDate.enable();
    };
    return ExperimentDetailsShowHideService;
}());
export { ExperimentDetailsShowHideService };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/services/experiment-details-show-hide.service.ts.pre-build-optimizer.js